module.exports = __webpack_public_path__ + "img/personal_icon_reward@2x.2decbcc9.png";